import {CallAPI, GetCookieFunction, RemoveCookieFunction, CapitalizeWord} from '../utils/util.js';
import ProfileImg from '../resources/images/icon_patients.png';
import CheckinImg from '../resources/images/icon_checkin.png';
import EditImg from '../resources/images/icon_edit.png';
import React, { Component } from "react";

class UserHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            "name": "",
            "email": "",
            "completed": 0,
            "current": 0,
            "waiting": 0,
            "todaySchedule": [],
            "confirmCancelId": null
        }
        this.centerId = GetCookieFunction("Center").id;
        this.isAdmin = GetCookieFunction("User").type === "centeradmin" || GetCookieFunction("User").type === "executive";
        RemoveCookieFunction("Patient_ID");
    }

    componentDidMount() {
        CallAPI({}, `users/info/${GetCookieFunction("User").id}`, 'GET', (res) => {
            this.setState({"name": `${res.fName} ${res.lName}`, "email": res.email});
        });
        CallAPI({}, `centers/status/${GetCookieFunction("Center").id}`, 'GET', (res) => {
            this.setState({
                "current":   res.current   ?? 0,
                "completed": res.completed ?? 0,
                "waiting":   res.waiting   ?? 0
            });
        });

        // Load today's schedule
        const now = new Date();
        const today = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;
        this.loadTodaySchedule(today);
    }

    loadTodaySchedule = (date) => {
        const fallback = (() => { const n=new Date(); return `${n.getFullYear()}-${String(n.getMonth()+1).padStart(2,'0')}-${String(n.getDate()).padStart(2,'0')}`; })();
        CallAPI({}, `scheduling/daily?centerId=${this.centerId}&date=${date || fallback}`, 'GET', (res) => {
            if (res.success) {
                this.setState({ todaySchedule: res.data });
            }
        });
    }

    handleCancelSchedule = (scheduleId) => {
        this.setState({ confirmCancelId: scheduleId });
    }

    confirmCancel = () => {
        const scheduleId = this.state.confirmCancelId;
        this.setState({ confirmCancelId: null });
        CallAPI({}, `scheduling/book/${scheduleId}?centerId=${this.centerId}`, 'DELETE', (res) => {
            if (res.success) this.loadTodaySchedule();
        });
    }

    adminOptions() {
        const user = GetCookieFunction("User");
        if (user.admin === 1 || user.type === "centeradmin" || user.type === "executive") {
            return (
                <>
                    <a href="/admin/users/create" className="menu-card">
                        <img src={EditImg} alt="" />
                        <span>Create a Staff Account</span>
                    </a>
                    <a href="/admin/users/lookup" className="menu-card">
                        <img src={EditImg} alt="" />
                        <span>Manage Staff</span>
                    </a>
                    <a href="/admin/reports" className="menu-card">
                        <img src={EditImg} alt="" />
                        <span>Reports</span>
                    </a>
                </>
            );
        }
    }

    render = () => {
        const user = GetCookieFunction("User");
        const userType = user ? CapitalizeWord(user.type) : "";

        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-header">
                    <h2>{this.state.name}</h2>
                    <p>{this.state.email} &nbsp;·&nbsp; {userType}</p>
                </div>

                <div className="stats-row">
                    <div className="stat-card green">
                        <div className="stat-value">{this.state.completed}</div>
                        <div className="stat-label">Completed</div>
                    </div>
                    <div className="stat-card yellow">
                        <a href="/patients/lookup?intreatment=true" className="stat-value">{this.state.current}</a>
                        <div className="stat-label">In Treatment</div>
                    </div>
                    <div className="stat-card red">
                        <div className="stat-value">{this.state.waiting}</div>
                        <div className="stat-label">Waiting</div>
                    </div>
                </div>

                <div className="menu-grid">
                    <a href="/patients/lookup" className="menu-card">
                        <img src={ProfileImg} alt="" />
                        <span>Lookup a Patient</span>
                    </a>
                    <a href="/patients/lookup?checkedIn=true" className="menu-card">
                        <img src={CheckinImg} alt="" />
                        <span>View Checked-In Patients</span>
                    </a>
                    <a href="/patients/create/personal?funnel=1" className="menu-card">
                        <img src={EditImg} alt="" />
                        <span>Register a New Patient</span>
                    </a>
                    {this.adminOptions()}
                </div>

                {/* Today's Schedule */}
                {this.state.todaySchedule.length > 0 && (
                    <div style={{marginTop: '28px'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px'}}>
                            <h3 style={{fontSize: '16px', fontWeight: 700, color: 'var(--text-primary)', margin: 0}}>Today's Schedule</h3>
                            <a href="/schedule/daily" style={{fontSize: '13px', color: 'var(--primary)', textDecoration: 'none'}}>View full →</a>
                        </div>
                        <div className="daily-schedule-slots">
                            {this.state.todaySchedule.map(slot => (
                                <div key={slot.slotId} className="daily-schedule-slot">
                                    <div className="daily-schedule-slot-header available">
                                        <span className="daily-schedule-slot-time">
                                            {(() => { const [h,m] = slot.startTime.split(':'); const hr = parseInt(h)%12||12; return `${hr}:${m} ${parseInt(h)>=12?'PM':'AM'}`; })()}
                                            {' – '}
                                            {(() => { const [h,m] = slot.endTime.split(':'); const hr = parseInt(h)%12||12; return `${hr}:${m} ${parseInt(h)>=12?'PM':'AM'}`; })()}
                                        </span>
                                        <span className="daily-schedule-slot-count">{slot.patients.length} patients</span>
                                    </div>
                                    <div className="daily-schedule-patients">
                                        {slot.patients.length === 0 ? (
                                            <div className="daily-schedule-empty">No patients scheduled</div>
                                        ) : (
                                            slot.patients.map(p => (
                                                <div key={p.scheduleId} className="daily-schedule-patient">
                                                    <a href={`/patients/${p.patientId}/profile`} style={{color: 'var(--primary)', textDecoration: 'none', flex: 1, fontWeight: 500, fontSize: '13px'}}>
                                                        {p.firstName} {p.lastName}
                                                    </a>
                                                    {p.patientCode && <span className="daily-schedule-code">{p.patientCode}</span>}
                                                    {this.isAdmin && (
                                                        <button type="button" className="editable-delete-btn"
                                                            onClick={() => this.handleCancelSchedule(p.scheduleId)}>✕</button>
                                                    )}
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Cancel Confirmation Modal */}
                {this.state.confirmCancelId && (
                    <div className="ci-modal-overlay" onClick={() => this.setState({ confirmCancelId: null })}>
                        <div className="ci-modal" onClick={(e) => e.stopPropagation()}>
                            <h3>Cancel Appointment</h3>
                            <p style={{fontSize: '14px', color: 'var(--text-secondary)', margin: '12px 0'}}>
                                Are you sure you want to cancel this appointment?
                            </p>
                            <div className="ci-submit-row">
                                <button type="button" className="homeButton" onClick={() => this.setState({ confirmCancelId: null })}>Keep</button>
                                <button type="button" className="logSubmit" style={{width: 'auto', background: 'var(--danger)'}} onClick={this.confirmCancel}>Cancel Appointment</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };
}

export default UserHome;
